export const IMAGE_TOOL_ID = "image";

export const imageToolConfig = {
  id: IMAGE_TOOL_ID,
  usesPreview: false,
  cursor: "copy",
  onStart: () => true,
  onMove: () => {},
  onEnd: () => {},
};

const ImageToolButton = ({ activeTool, onSelectTool, onPickImage }) => {
  const isActive = activeTool === IMAGE_TOOL_ID;

  return (
    <button
      type="button"
      className={`btn ${isActive ? "btn-dark" : "btn-outline-dark"}`}
      onClick={() => {
        onSelectTool(IMAGE_TOOL_ID);
        onPickImage?.();
      }}
      title="Insert image"
      aria-label="Insert image"
    >
      🖼
    </button>
  );
};

export default ImageToolButton;